import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseWrongPaymentMethodOnDocumentWithSplitPaymentWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.purchase.validation.wrong-payment-method-on-document-with-split-payment.message');
    }
}
